<template>
    <b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true id="popup-upload" @ok="uploadButtonAction" :okTitle="okTitle" title="Upload Data">
        <b-card>
            <b-row>
                <b-col cols="12">
                    <app-input-fileupload label="File" size="sm" :model.sync="fileupload" />
                </b-col>
            </b-row>
            <b-row v-if="isUploadSuccess">
                <b-col cols="12">
					<b-card no-body>
						<b-tabs card>
							                            <b-tab title="Upload Outgoing Check" active>

                                <b-row v-if="hasFailedDataOutgoingCheck">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedOutgoingCheck.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="outgoingChecksFailed" :fields="fieldsOutgoingCheck" :busy="isDataLoading"
                                                         :sort-by.sync="sortByOutgoingCheck" :sort-desc.sync="sortDescOutgoingCheck" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(processDate)="row">
													{{ row.item.processDate | moment("DD-MMM-YYYY HH:mm") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedOutgoingCheck.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="outgoingChecks" :fields="fieldsOutgoingCheck" :busy="isDataLoading"
                                                         :sort-by.sync="sortByOutgoingCheck" :sort-desc.sync="sortDescOutgoingCheck" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(processDate)="row">
													{{ row.item.processDate | moment("DD-MMM-YYYY HH:mm") }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>                            <b-tab title="Upload Outgoing Check Detail" active>

                                <b-row v-if="hasFailedDataOutgoingCheckDetail">
                                    <b-col>
                                        <b-button variant="danger" v-b-toggle.failed-content class="m-1">Invalid Data ({{ totalFailedOutgoingCheckDetail.toLocaleString() }})</b-button>
                                        <b-collapse visible id="failed-content">
                                            <div class="table-corner">
                                                <b-table id="failed-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="outgoingCheckDetailsFailed" :fields="fieldsOutgoingCheckDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByOutgoingCheckDetail" :sort-desc.sync="sortDescOutgoingCheckDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(deliveryQty)="row">
													{{ Number(row.item.deliveryQty).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                                <b-row>
                                    <b-col>
                                        <b-button variant="success" v-b-toggle.success-content class="m-1">Valid Data ({{ totalSucceedOutgoingCheckDetail.toLocaleString() }})</b-button>
                                        <b-collapse id="success-content">
                                            <div class="table-corner">
                                                <b-table id="success-table" stacked="md" head-variant="head-light" :no-local-sorting="true"
                                                         :items="outgoingCheckDetails" :fields="fieldsOutgoingCheckDetail" :busy="isDataLoading"
                                                         :sort-by.sync="sortByOutgoingCheckDetail" :sort-desc.sync="sortDescOutgoingCheckDetail" small responsive>
                                                    <template v-slot:table-busys>
                                                        <div class="text-center my-2">
                                                            <b-spinner class="align-middle text-primary"></b-spinner>
                                                            <strong class="ml-2">Loading..</strong>
                                                        </div>
                                                    </template>
												<template #cell(deliveryQty)="row">
													{{ Number(row.item.deliveryQty).toLocaleString() }}
												</template>

                                                    <template #cell(uploadValidationMessageHtml)="data">
                                                        <span v-html="data.value"></span>
                                                    </template>
                                                </b-table>
                                            </div>
                                        </b-collapse>
                                    </b-col>
                                </b-row>

                            </b-tab>

						</b-tabs>
					</b-card>
                </b-col>
            </b-row>
        </b-card>
        <template #modal-footer="{ ok, cancel }">
            <b-button v-if="isUploadSuccess" size="sm" variant="primary" @click="downloadLog()">
                Download Log
            </b-button>
            <b-button size="sm" variant="success" class="float-right" @click="ok()">
                {{ okTitle }}
            </b-button>
            <b-button size="sm" variant="secondary" class="float-right" @click="cancel()">
                Cancel
            </b-button>
        </template>
        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </b-modal>
</template>
<style lang="scss" scoped>
    .card {
        border: 1px solid rgba(0, 0, 0, 0.125) !important;
    }

    ::v-deep.th-message {
        color: red;
    }

    ::v-deep.modal-footer {
        display: block;
    }
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { saveAs } from 'file-saver';

import OutgoingCheck from '@/models/OutgoingCheck/OutgoingCheck';
import OutgoingCheckList from '@/models/OutgoingCheck/OutgoingCheckList';
import OutgoingCheckFilter from '@/filters/OutgoingCheck/OutgoingCheckFilter';

import AppInputFileupload from '@/components/AppInputFileupload';

export default {
	props: ['model', 'openPopup','uploadButtonMethod', 'parentId'],
	components : {AppInputFileupload,},
	data() {
		return {
			fileupload: null,
			uploadProcessId: null,
			datas: Array(),
			fieldsOutgoingCheck: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Delivery Instruction", key: 'deliveryInstructionDiNumber', sortable: false},
				{"class" : "th-status", "label" : "Process By", key: 'processByFirstName', sortable: false},
				{"class" : "th-status", "label" : "Process Date", key: 'processDate', sortable: false},
				{"class" : "th-status", "label" : "Outgoing Check Status", key: 'outgoingCheckStatusName', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],
			fieldsOutgoingCheckDetail: [
				// {"no" : { "class" : "th-number"}},
				{"class" : "th-id", "label" : "Excel Row", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Id", key: 'id', sortable: false},
				{"class" : "th-status", "label" : "Name", key: 'name', sortable: false},
				{"class" : "th-status", "label" : "Delivery Instruction Detail", key: 'deliveryInstructionDetailPart', sortable: false},
				{"class" : "th-status", "label" : "Part", key: 'partPartNumber', sortable: false},
				{"class" : "th-status", "label" : "Delivery Qty", key: 'deliveryQty', sortable: false},
				{"class" : "th-status", "label" : "Is Completed", key: 'isCompleted', sortable: false},

				{"class" : "th-status", "label" : "Status", key: 'uploadValidationStatus', sortable: false},
				{"class" : "th-message", "label" : "Message", key: 'uploadValidationMessageHtml', sortable: false},
				{"actions": { "class" : "th-actions", "label" : "" }}
			],

			busy:false,
			isDataLoading: false,
			isBusy : false,
			outgoingChecks : [],
			outgoingChecksFailed: [],
			outgoingCheckId : '',
			sortByOutgoingCheck: '',
			sortDescOutgoingCheck: '',
			hasFailedDataOutgoingCheck: false,
			totalFailedOutgoingCheck: 0,
			totalSucceedOutgoingCheck: 0,
			outgoingCheckDetails : [],
			outgoingCheckDetailsFailed: [],
			outgoingCheckDetailId : '',
			sortByOutgoingCheckDetail: '',
			sortDescOutgoingCheckDetail: '',
			hasFailedDataOutgoingCheckDetail: false,
			totalFailedOutgoingCheckDetail: 0,
			totalSucceedOutgoingCheckDetail: 0,


			processId: '',
			isUploadSuccess: false,
		}
	},
	methods : {
		resetModal() {
			this.datas = Array();
			this.isUploadSuccess = false;
			this.$emit('resetMethod');
		},
		uploadButtonAction(modalEvent) {
			modalEvent.preventDefault();
			this.isBusy = true;
			if (this.isUploadSuccess) {
				let _this = this;
				this.$http.post('outgoingcheck/confirmUpload/' + _this.uploadProcessId,
					[],
					).then(async function(response){
						if (response != null) {
							if (response.data != null) {
								_this.resetModal();
								_this.datas = Array();
								_this.fileupload = null;
								_this.isUploadSuccess = false;
							}
						}
						_this.isBusy = false;
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
			} else {
				if (this.fileupload != null) {
					let data = new FormData();
					data.append('file', this.fileupload);
					let _this = this;
					this.$http.post('outgoingcheck/upload',
						data,
						{ headers: { 'Content-Type': 'multipart/form-data' } }
					).then(async function(response){
						_this.uploadProcessId = response.data.id;
						_this.isUploadSuccess = true;
						await _this.getOutgoingCheckForUpload();
					})
					.catch(error => {
						_this.$store.dispatch('addErrorMessageGlobal', error);
						_this.isBusy = false;
					});
				}
			}
		},
		getOutgoingCheckForUpload : async function() {
			let _this = this;
			this.$http.get('outgoingcheck/uploadresult/' + _this.uploadProcessId)
				.then(async function(response) {
					_this.outgoingChecks = [];
_this.outgoingCheckDetails = [];


					if (response != null) {
						let result = response.data;
						_this.outgoingChecks = result.filter(o => { return o.uploadValidationStatus == "Success"});
                        _this.totalSucceedOutgoingCheck = _this.outgoingChecks.length;

						_this.outgoingChecksFailed = result.filter(o => { return o.uploadValidationStatus != "Success"});
						_this.hasFailedDataOutgoingCheck = true;
						_this.totalFailedOutgoingCheck = 0;
						if(_this.outgoingChecksFailed == undefined || _this.outgoingChecksFailed.length === 0) _this.hasFailedDataOutgoingCheck = false;
						if(_this.hasFailedDataOutgoingCheck) _this.totalFailedOutgoingCheck = _this.outgoingChecksFailed.length;
						_this.outgoingCheckDetails = [];
						_this.outgoingCheckDetailsFailed = [];
						_this.hasFailedDataOutgoingCheckDetail = true;
						_this.totalSucceedOutgoingCheckDetail = 0;
						result.forEach(function(element) {
							_this.outgoingCheckDetails.push(...element.outgoingCheckDetail.filter(o => { return o.uploadValidationStatus == "Success"}));
							_this.totalSucceedOutgoingCheckDetail = _this.outgoingCheckDetails.length;

							_this.outgoingCheckDetailsFailed.push(...element.outgoingCheckDetail.filter(o => { return o.uploadValidationStatus != "Success"}));
							if(_this.outgoingCheckDetailsFailed == undefined || _this.outgoingCheckDetailsFailed.length === 0) _this.hasFailedDataOutgoingCheckDetail = false;
							if(_this.hasFailedDataOutgoingCheckDetail) _this.totalFailedOutgoingCheckDetail = _this.outgoingCheckDetailsFailed.length;
						});
						_this.isBusy = false;
					}
				})
				.catch(error => {
					_this.$store.dispatch('addErrorMessageGlobal', error);
					_this.isBusy = false;
				});
		},
		downloadLog() {
			let _this = this;
			let url = 'outgoingcheck/downloadlog/' + _this.uploadProcessId;
			this.$http.get(url, {responseType: 'blob'}).then(async response => {
				if (response != null) {
					await saveAs(response.data, 'OutgoingCheck.xlsx');
				}
			}).catch(error => {
				this.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
		}
	},
	beforeMount() {
	},
	mounted(){
	},
	watch: {
		fileupload(newValue, oldValue) {
			this.datas = Array();
			this.isUploadSuccess = false;
		}
	},
	computed: {
		okTitle: {
			get: function() {
				if (this.isUploadSuccess) {
					return "Process";
				}
				return "Upload";
				}
		},
		isShowPopup : {
			get: function () {
				if (this.openPopup) {
					this.filterOutgoingCheck = new OutgoingCheckFilter();
					return true;
				}
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
